import { useState } from "react";
import { Alert, Button, Card, Form, Input, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, ApiError } from "../api/client";
import { palette } from "../theme";
import { BrandBlock, LangSwitch } from "./LoginPage";
import { useIsMobile } from "../components/useIsMobile";

/** Password dimenticata: la risposta è sempre la stessa, esista o no l'account. */
export default function ForgotPage() {
  const { t } = useTranslation();
  const mobile = useIsMobile();
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (v: { email: string }) => {
    setBusy(true);
    setErr(null);
    try {
      // sensitive-ok: invio del form, pagina pubblica
      await api.post("/auth/forgot-password", { email: v.email.trim() });
      setSent(true);
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : t("a_loginFail"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: palette.bg, padding: mobile ? 12 : 16 }}>
      <Card style={{ width: "100%", maxWidth: 440 }} styles={{ body: { padding: mobile ? 20 : 28 } }}>
        <Space direction="vertical" size={20} style={{ width: "100%" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <BrandBlock />
            <LangSwitch />
          </div>
          <div>
            <Typography.Title level={3} style={{ margin: 0, color: palette.heading }}>{t("c_forgotTitle")}</Typography.Title>
            {!sent && <Typography.Text type="secondary">{t("c_forgotSub")}</Typography.Text>}
          </div>
          {err && <Alert type="error" showIcon message={err} />}
          {sent ? (
            <Alert type="success" showIcon message={t("c_forgotSent")} />
          ) : (
            <Form layout="vertical" onFinish={submit} requiredMark={false} disabled={busy}>
              <Form.Item name="email" label={t("email")} rules={[{ required: true, type: "email", message: t("a_emailInvalid") }]}>
                <Input autoComplete="username" autoFocus={!mobile} size="large" inputMode="email" style={{ fontSize: 16 }} />
              </Form.Item>
              <Button type="primary" htmlType="submit" block size="large" loading={busy} style={{ height: 48 }}>{t("c_forgotSend")}</Button>
            </Form>
          )}
          <div style={{ textAlign: "center" }}><Link to="/login">{t("c_backLogin")}</Link></div>
        </Space>
      </Card>
    </div>
  );
}
